export default "__VITE_PUBLIC_ASSET__673d48d0__"